/**
 * Web Storage access that never throws (private mode, blocked storage, sandboxed kiosks).
 */
export interface SafeStorage {
  get(key: string): string | null
  set(key: string, value: string): void
  remove(key: string): void
}

export function safeStorage(kind: 'local' | 'session'): SafeStorage {
  const resolve = (): Storage | null => {
    try {
      return kind === 'local' ? window.localStorage : window.sessionStorage
    } catch {
      return null
    }
  }
  return {
    get: (key) => {
      try {
        return resolve()?.getItem(key) ?? null
      } catch {
        return null
      }
    },
    set: (key, value) => {
      try {
        resolve()?.setItem(key, value)
      } catch {
        // storage unavailable — preference is simply not remembered
      }
    },
    remove: (key) => {
      try {
        resolve()?.removeItem(key)
      } catch {
        // ignore
      }
    },
  }
}
